import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ValuesSection from './components/ValuesSection';
import ProgramsSection from './components/ProgramsSection';
import CommunitySection from './components/CommunitySection';
import NewsletterSection from './components/NewsletterSection';
import ContactSection from './components/ContactSection';
import SEOHead from '../../components/feature/SEOHead';

export default function Home() {
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://crownabundance.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'The CROWN Abundance Movement',
    'alternateName': 'House of CROWN',
    'description': 'A global empowerment movement focused on wealth mastery, relationship wholeness, and generational legacy',
    'url': baseUrl,
    'logo': `${baseUrl}/logo.png`,
    'sameAs': [
      'https://facebook.com/crownabundance',
      'https://instagram.com/crownabundance',
      'https://linkedin.com/company/crown-abundance'
    ],
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+27-12-345-6789',
      'contactType': 'customer service',
      'email': 'info@nowabundance.com',
      'areaServed': 'ZA',
      'availableLanguage': 'English'
    },
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': '116 Limpopo Avenue, Doringkloof',
      'addressLocality': 'Centurion',
      'postalCode': '0157',
      'addressCountry': 'ZA'
    }
  };

  return (
    <>
      <SEOHead
        title="CROWN Abundance Movement | Wealth, Relationships & Legacy Mastery"
        description="Join The CROWN Abundance Movement - a global community empowering entrepreneurs, founders, and families in wealth mastery, relationship wholeness, and generational legacy."
        keywords="wealth mastery, relationship wholeness, generational legacy, entrepreneurs, founders, investors, abundance movement"
        canonicalPath="/"
        type="Organization"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen" style={{ background: '#3D2C8D' }}>
        <HeroSection />
        <AboutSection />
        <ValuesSection />
        <ProgramsSection />
        <CommunitySection />
        <NewsletterSection />
        <ContactSection />
      </div>
    </>
  );
}
